<template>
<!--  class="mt-2" style="width: 98%; background-color: white"-->
  <v-container fluid>
    <v-container fluid class="app-container">
      <router-view></router-view>
    </v-container>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
  .app-container {
    max-width: 1920px;
    border-radius: 2px;
    background-color: white;
    min-height: 500px;
  }
</style>
